{
  "undo": "Отменить",
  "redo": "Повторить",
  "bold": "Жирный",
  "italic": "Курсив",
  "mono": "Моноширинный",
  "mark": "Выделенный",
  "underline": "Подчеркивание",
  "strike": "Зачеркивание",
  "text": "Текст",
  "heading": "Заголовок",
  "heading1": "Заголовок 1",
  "heading2": "Заголовок 2",
  "heading3": "Заголовок 3",
  "heading4": "Заголовок 4",
  "heading5": "Заголовок 5",
  "heading6": "Заголовок 6",
  "list": "Список",
  "ulist": "Маркированный список",
  "olist": "Нумерованный список",
  "list__action_sink": "Увеличить отступ",
  "list__action_lift": "Уменьшить отступ",
  "list_action_disabled": "Противоречит логике списка",
  "checkbox": "Контрольный список",
  "quote": "Цитата",
  "cut": "Кат",
  "note": "Примечание",
  "table": "Таблица",
  "link": "Ссылка",
  "code": "Код",
  "code_inline": "Код в тексте",
  "codeblock": "Блок кода",
  "image": "Изображение",
  "hrule": "Разделитель",
  "emoji": "Эмодзи",
  "file": "Файл",
  "math": "Формула",
  "math_inline": "Формула в тексте",
  "math_block": "Блок с формулой",
  "colorify": "Цвет текста",
  "colorify__group_text": "Текст",
  "colorify__color_default": "Стандартный",
  "colorify__color_gray": "Серый",
  "colorify__color_yellow": "Жёлтый",
  "colorify__color_orange": "Оранжевый",
  "colorify__color_red": "Красный",
  "colorify__color_green": "Зелёный",
  "colorify__color_blue": "Синий",
  "colorify__color_violet": "Фиолетовый",
  "more_action": "Другие действия",
  "tabs": "Табы",
  "mermaid": "Mermaid"
}
